import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';

import { media } from '../data/cloudinary';
import { routeUrls } from '../config/routes';
import { forgotPassword } from '../redux/actions';

const ForgotPass = ({ showLogo, onLogoClick }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const loader = useSelector(state => state.loader);
  const [browniteInfo, setBrowniteInfo] = useState({
    matricNumber: '',
  });
  const handleInput = e => {
    setBrowniteInfo(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = event => {
    event.preventDefault();
    dispatch(forgotPassword(browniteInfo));
  };

  return (
    <Form onSubmit={handleSubmit}>
      {showLogo && (
        <div className="text-center pb-4">
          <img
            src={media.logo}
            className="rounded"
            style={{ width: 60, height: 60, cursor: 'pointer' }}
            alt="logo"
            onClick={onLogoClick}
          />
        </div>
      )}
      <FormGroup>
        <Label for="matricNumber">Matric Number</Label>
        <Input
          type="number"
          id="matricNumber"
          value={browniteInfo.matricNumber}
          onChange={handleInput}
          name="matricNumber"
          placeholder="Your matriculation number"
        />
      </FormGroup>
      <FormGroup style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          size="lg"
          className="bg-gradient-theme-left border-0"
          block
          onClick={handleSubmit}
        >
          Send Reset Link{' '}
          {loader && loader.forgotPassword && (
            <Spinner color="light" size="sm" />
          )}
        </Button>
      </FormGroup>
      <div className="text-center pt-1">
        <h6>or</h6>
        <h6>
          <p onClick={() => history.goBack()} style={{ cursor: 'pointer' }}>
            Go back
          </p>
        </h6>
      </div>
    </Form>
  );
};

ForgotPass.propTypes = {
  showLogo: PropTypes.bool,
  onLogoClick: PropTypes.func,
};

ForgotPass.defaultProps = {
  showLogo: true,
  onLogoClick: () => {},
};
export default ForgotPass;
